var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdditionalInfoVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93323 11.4254H3.43654C2.97266 11.4254 2.59668 11.0243 2.59668 10.5295V5.47056C2.59668 4.97576 2.97266 4.57471 3.43654 4.57471H9.93323C10.3971 4.57471 10.7731 4.97576 10.7731 5.47056V10.5295C10.7731 11.0243 10.3971 11.4254 9.93323 11.4254Z",
    fill: "#343435"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6825 10.292L11.3223 9.39779V6.60219L13.6825 5.70801C14.0343 5.5748 14.4039 5.85313 14.4039 6.25138V9.74874C14.4039 10.1469 14.0343 10.4252 13.6825 10.292Z",
    fill: "#343435"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalInfoVideoIcon);
export default __webpack_public_path__ + "static/media/AdditionalInfoVideoIcon.07e8374bc13e20d9e5d78355e9f0ecf4.svg";
export { ForwardRef as ReactComponent };